import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Restaurant} from "../../shared/model/restaurant";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../shared/security/auth.service";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {navigationCancelingError} from "@angular/router/src/shared";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";

@Component({
  selector: 'app-email-us',
  templateUrl: './email-us.component.html',
  styleUrls: ['./email-us.component.css']
})
export class EmailUsComponent implements OnInit {
   form: FormGroup;
  private restaurant: Restaurant;
   currentRestaurantName : string;
  private currentTime:string;
   currentUser:string;
   currentUserEmail:string;

  constructor(
    private route:ActivatedRoute,
    private fb: FormBuilder,
    private router:Router,
    private authService: AuthService,
    private restaurantService:RestaurantService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,


  ) {
    route.data
      .subscribe( ( data ) =>
        {
          this.restaurant = data.restaurant;

          this.setRestaurantFields();
        }

      )

    overlay.defaultViewContainer = vcRef;


  }

  private setRestaurantFields() {
     this.currentRestaurantName = this.restaurant.restaurant;
  }

  ngOnInit() {

    this.form = this.fb.group({
      subject:['',[Validators.required]],
      message:['',Validators.required]
    });

    this.currentUser = this.authService.getDispName();
    this.currentUserEmail = this.authService.getEmailAdd();

  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  cancel() {
    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});
  }

  save(form) {
    // console.log("Showing Form Values ");
    // console.log(form.value);
    if (form.invalid){
      this.showErrors();
    } else {
      //TODO : Transform this into and Model Object (CS Message)
      let messObj = {
        "restaurantId":this.restaurant.$key,
        "user":this.currentUser,
        "email":this.currentUserEmail,
        "datatime": new Date(),
        "subject":form.value.subject,
        "message":form.value.message,
        "answer":'',
        "answeertime":'',
        "answerby":'',
        "answerit":false,
        "sentToCS":false
      };

      this.sendMessage(messObj);
    }
  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
  }

  reset() {
    this.form.reset();

  }


  private sendMessage(messObj: {
    restaurantId:string;
    user: string;
    email: string;
    datatime: Date;
    subject;
    message;
    answer: string;
    answeertime: string;
    answerby: string;
    answerit: boolean;
    sentToCS:boolean
  }) {
    this.restaurantService.addMessage(messObj).subscribe( () => {
      // console.log("message added");
      this.messageIt('Message Sent','Thank you for contacting us! Customer Service will contact you as soon as possible');
    });

    this.navigateToAccountingPage();



  };

  private navigateToAccountingPage() {
    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});


  }


  private messageIt(titleP:string,messageP:string){
    this.modal.alert()
      .size('lg')
      .isBlocking(true)
      .keyboard(27)
      .okBtn('OK')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => { this._cleanup()})
  }

  _cleanup(){

  }

}



// WEBPACK FOOTER //
// ./src/app/contact-us/email-us/email-us.component.ts